<ion-content>
  <div class="scroll-content-modal">
    <app-header-modal 
      class="header"
      [title]="title" 
      [showToggle]="true"
      [showClose]="true"
      (close)="dismiss()">
    </app-header-modal>
    
    <div class="article-content">
      <app-article [content]="content" (buttonClick)="onButtonClick($event)"></app-article>
    </div>

    @if (showAcceptButton) {
      <div class="accept-button-container">
        <button 
          class="push-btn primary-color-button full-width-button"
          (click)="onAccept()">
          {{ acceptButtonText }}
        </button>
      </div>
    }
  </div>
</ion-content>
